import { render, staticRenderFns } from "./Reflexologie.vue?vue&type=template&id=59adacdf&scoped=true"
import script from "./Reflexologie.vue?vue&type=script&lang=js"
export * from "./Reflexologie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59adacdf",
  null
  
)

export default component.exports